<template>
  <div id="app">
    <splash-screen v-if="sessionStorageProcess && (getSplashUrl === 'splash_egy')"></splash-screen>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import { Howler } from 'howler';
import initCacheServiceWorker from '@/common/cacheServiceWorker';
import SplashScreen from '@/SplashScreen';

export default {
  components: { SplashScreen },
  name: 'app',
  created() {
    this.getVersionInfo();
    this.enableGTM();
    this.getFbInfo();
    this.addExternalSEOScript();
    this.updateSoundsStatusFromLocaleStorage();
    // Setting global audio volume.
    Howler.volume(0.8);
    initCacheServiceWorker();
  },
  computed: {
    ...mapGetters('common', [
      'getSplashUrl',
    ]),
    sessionStorageProcess() {
      if (sessionStorage.getItem('splashScreenAlreadyDisplayed') !== 'true' && sessionStorage.getItem('splashScreenProgrammaticallyRefresh') !== 'true') {
        return true;
      }
      sessionStorage.setItem('splashScreenProgrammaticallyRefresh', 'false');
      return false;
    },
  },
  methods: {
    ...mapActions('common', [
      'storeVersionInfo',
    ]),
    ...mapMutations('common', [
      'updateSoundsStatusFromLocaleStorage',
      'setFbAppId',
    ]),
    getVersionInfo() {
      this.storeVersionInfo();
    },
    enableGTM() {
      this.$axios('publicapi/getGTMInfo').then((response) => {
        const key = response.data.data;
        if (key) {
          /* eslint-disable */
          // add GMT noscript (no js support case) to body
          const oldNoScript = document.querySelector('#gtmNoScript');
          if (!oldNoScript) {
            const noscript = document.createElement('noscript');
            noscript.setAttribute('id', 'gtmNoScript');
            noscript.innerHTML = `<iframe height="0" width="0" style="display:none;visibility:hidden" src="https://www.googletagmanager.com/ns.html?id=${key}"></iframe>`;
            document.body.insertBefore(noscript, document.body.childNodes[0]);
          }
          // add GMT script to head
          const oldScript = document.querySelector('#gtmScript');
          if (!oldScript) {
            const script = document.createElement('script');
            script.setAttribute('id', 'gtmScript');
            script.innerHTML = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','" + key + "')";
            document.head.appendChild(script);
          }
          /* eslint-enable */
        }
      });
    },
    getFbInfo() {
      this.$axios('publicapi/getFbInfo').then((response) => {
        this.setFbAppId({ value: response.data.data });
        /* eslint-disable */
        (function (d, s, id) {
         var js, fjs = d.getElementsByTagName(s)[0];
         if (d.getElementById(id)) return;
         js = d.createElement(s);
         js.id = id;
         js.src = "//connect.facebook.net/en_US/sdk.js#version=v6.0&appId=" + response.data.data + "&status=true&cookie=true&xfbml=true";
         fjs.parentNode.insertBefore(js, fjs);
       }(document, 'script', 'facebook-jssdk'));
       /* eslint-enable */
      });
    },
    addExternalSEOScript() {
      const script = document.createElement('script');
      script.setAttribute('type', 'application/ld+json');
      script.innerHTML = '{ "@context" : "http://schema.org", "@type" : "SoftwareApplication", "name" : "Duel Multiplayer Trivia Game", "image" : "https://www.duel.ae/static/images/get_started.png", "url" : "https://www.duel.ae/#/login", "aggregateRating" : { "@type" : "AggregateRating", "ratingValue" : "5" } }';
      document.body.appendChild(script);
    },
  },
};
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue